(function () {

const API = "https://stylavoteam.com/customers/api/customer-event.php";

function uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === "x" ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

let visitorKey = localStorage.getItem("visitor_key");

if (!visitorKey) {
    visitorKey = uuid();
    localStorage.setItem("visitor_key", visitorKey);
}

let sessionId = sessionStorage.getItem("session_id");

if (!sessionId) {
    sessionId = uuid();
    sessionStorage.setItem("session_id", sessionId);
}

function getProduct() {
    const productContainer = document.querySelector(
        '[data-testid="product-information-details"]'
    );

    const variantPicker = document.querySelector(
        'variant-picker[data-product-id]'
    );

    const variantInput = document.querySelector(
        'form[action="/cart/add"] input[name="id"]'
    );

    const selectedSize = document.querySelector(
        'variant-picker input[type="radio"][data-option-name="Size"]:checked'
    );

    const productIdInput = document.querySelector(
        'form[action="/cart/add"] input[name="product-id"]'
    );

    let productTitle = "";

    if (variantPicker?.dataset.productTitle) {
        productTitle = variantPicker.dataset.productTitle.trim();
    } else {
        productTitle =
            productContainer?.querySelector(".view-product-title a")?.innerText?.trim() ||
            productContainer?.querySelector("h1, h2")?.innerText?.trim() ||
            "";
    }

    const price =
        productContainer?.querySelector("product-price .price")?.innerText?.trim() || "";

    return {
        product_id:
            productIdInput?.value ||
            variantPicker?.dataset.productId ||
            "",

        variant_id:
            selectedSize?.dataset.variantId ||
            variantInput?.value ||
            "",

        product_title: productTitle,
        selected_size: selectedSize?.value || "",
        product_price: price,
        product_handle: variantPicker?.dataset.productHandle || ""
    };
}

function sendEvent(payload) {
    const json = JSON.stringify(payload);

    const blob = new Blob([json], {
        type: "text/plain"
    });

    if (navigator.sendBeacon) {
        try {
            const sent = navigator.sendBeacon(API, blob);

            if (sent) {
                return;
            }
        } catch (err) {
            console.error("sendBeacon failed:", err);
        }
    }

    fetch(API, {
        method: "POST",
        headers: {
            "Content-Type": "text/plain"
        },
        body: json,
        keepalive: true,
        mode: "cors"
    }).catch(function (err) {
        console.error("Tracking fetch failed:", err);
    });
}

function trackEvent(eventName, extra = {}, element = null) {
    const email = localStorage.getItem("userEmail") || "";
    const phone =
  localStorage.getItem("userPhone") ||
  localStorage.getItem("return_contact") ||
  "";

    sendEvent({
        visitor_key: visitorKey,
        session_id: sessionId,
        user_email: email,
        user_phone: phone,
        event_name: eventName,
        page_url: location.href,
        page_title: document.title,
        element_text:
            element?.innerText?.trim() ||
            element?.value ||
            "",
        element_id: element?.id || "",
        element_class:
            typeof element?.className === "string"
                ? element.className
                : "",
        extra_data: {
            ...getProduct(),
            ...extra
        }
    });
}

window.trackEvent = trackEvent;

function findClickedElement(event, selector) {
    const path = event.composedPath ? event.composedPath() : [];

    for (const item of path) {
        if (
            item instanceof Element &&
            item.matches(selector)
        ) {
            return item;
        }
    }

    if (event.target instanceof Element) {
        return event.target.closest(selector);
    }

    return null;
}

function getBuyNowButton(event) {
    const path = event.composedPath ? event.composedPath() : [];

    for (const node of path) {
        if (!(node instanceof Element)) continue;

        if (
            node.matches(".shopify-payment-button__button") ||
            node.matches("[data-function='buyNow']") ||
            node.matches("[data-gokwik-function='buyNow']")
        ) {
            return node;
        }
    }

    return null;
}

window.addEventListener("load", function () {
    const isProductPage =
        document.querySelector('form[action="/cart/add"]') ||
        document.querySelector("variant-picker[data-product-id]");

    if (isProductPage) {
        trackEvent("product_view");
    } else {
        trackEvent("page_view");
    }
});

document.addEventListener("change", function (event) {
    if (!(event.target instanceof Element)) {
        return;
    }

    if (
        event.target.matches(
            'variant-picker input[type="radio"][data-option-name="Size"]'
        )
    ) {
        trackEvent(
            "select_size",
            {
                size: event.target.value || "",
                variant_id: event.target.dataset.variantId || ""
            },
            event.target
        );

        return;
    }

    if (
        event.target.matches(
            'variant-picker input[type="radio"]'
        )
    ) {
        trackEvent(
            "select_variant",
            {
                option_name: event.target.dataset.optionName || "",
                option_value: event.target.value || "",
                variant_id: event.target.dataset.variantId || ""
            },
            event.target
        );
    }
});

document.addEventListener("click", function (event) {

    const buyNowBtn = getBuyNowButton(event);

    if (buyNowBtn) {
        trackEvent(
            "buy_now",
            {
                trigger: "click"
            },
            buyNowBtn
        );

        return;
    }

    const sizeGuide = findClickedElement(
        event,
        "#ci-sizechart-open"
    );

    if (sizeGuide) {
        trackEvent("size_guide", {}, sizeGuide);
        return;
    }

    const addToCart = findClickedElement(
        event,
        'button[name="add"], [data-testid="standalone-add-to-cart"], .add-to-cart-button'
    );

    if (addToCart) {
        trackEvent("add_to_cart", {}, addToCart);
        return;
    }

    const offerOpen = findClickedElement(
        event,
        "[data-stylavo-open], .stylavo-main-card"
    );

    if (offerOpen) {
        trackEvent(
            "discount_card_open",
            {
                offer_text: offerOpen.innerText?.trim() || ""
            },
            offerOpen
        );

        return;
    }

    const couponCopy = findClickedElement(
        event,
        "[data-stylavo-copy]"
    );

    if (couponCopy) {
        trackEvent(
            "coupon_copy",
            {
                coupon_code: couponCopy.dataset.couponCode || ""
            },
            couponCopy
        );

        return;
    }

    const offerToggle = findClickedElement(
        event,
        "[data-stylavo-toggle]"
    );

    if (offerToggle) {
        const card = offerToggle.closest(
            ".stylavo-coupon-card"
        );

        trackEvent(
            "offer_details_toggle",
            {
                coupon_code:
                    card
                        ?.querySelector("[data-coupon-code]")
                        ?.dataset
                        ?.couponCode || "",

                expanded:
                    offerToggle.getAttribute("aria-expanded") || ""
            },
            offerToggle
        );

        return;
    }

    const offerClose = findClickedElement(
        event,
        "[data-stylavo-close]"
    );

    if (offerClose) {
        trackEvent("discount_card_close", {}, offerClose);
        return;
    }

    const shareButton = findClickedElement(
        event,
        ".share-button__button"
    );

    if (shareButton) {
        trackEvent("share_clicked", {}, shareButton);
        return;
    }

    const copyLink = findClickedElement(
        event,
        ".button-copy"
    );

    if (copyLink) {
        trackEvent("copy_link", {}, copyLink);
        return;
    }

}, true);

document.addEventListener("toggle", function (event) {

    if (!(event.target instanceof HTMLDetailsElement)) {
        return;
    }

    const summary =
        event.target.querySelector(".details__header");

    if (!summary) {
        return;
    }

    const text =
        summary.innerText
            ?.trim()
            ?.toUpperCase() || "";

    if (
        text.includes("DESCRIPTION") &&
        event.target.open
    ) {
        trackEvent("description_open", {}, summary);
        return;
    }

    if (
        text.includes("SHIPPING") &&
        event.target.open
    ) {
        trackEvent("shipping_open", {}, summary);
    }

}, true);

})();





(function() {
  const phone =
  localStorage.getItem("userPhone") ||
  localStorage.getItem("return_contact") ||
  "";
  if (!phone) {
    localStorage.removeItem("historySynced");
  }

  if (localStorage.getItem("historySynced")) return;

  const page = {
    url: window.location.href,
    ts: Date.now()
  };

  let history = JSON.parse(localStorage.getItem("pageHistory") || "[]");
  history.push(page);
  localStorage.setItem("pageHistory", JSON.stringify(history));
})();

const waitForModal = setInterval(() => {
  const modal = document.querySelector('.ecomsend__Modal__CustomDialogWrapper');
  if (modal) {
    const emailInput = modal.querySelector('input[type="email"], #email');
    const phoneInput = modal.querySelector('input[type="tel"], .react-international-phone-input');

    function saveUserData() {
      const email = emailInput?.value.trim() || "";
      let rawPhone = phoneInput?.value.trim() || "";

      if (email) localStorage.setItem("userEmail", email);

      if (rawPhone) {
        let parts = rawPhone.split(" ");
        let localPart = parts.length > 1 ? parts.slice(1).join("").replace(/\D/g, "") : rawPhone.replace(/\D/g, "");

        if (localPart.length >= 10) {
          localStorage.setItem("userPhone", localPart.slice(-10));

          if (!localStorage.getItem("historySynced")) {
            syncUserData(true);
            localStorage.setItem("historySynced", "true");
            localStorage.removeItem("pageHistory");
          }
        }
      }
    }

    if (emailInput) emailInput.addEventListener("input", saveUserData);
    if (phoneInput) phoneInput.addEventListener("input", saveUserData);

    clearInterval(waitForModal);
  }
}, 500);

function syncUserData(initial = false) {
  const email = localStorage.getItem("userEmail") || "";
  const phone =
  localStorage.getItem("userPhone") ||
  localStorage.getItem("return_contact") ||
  "";
  if (!phone || phone.length < 10) return;

  let pages = initial
    ? JSON.stringify(JSON.parse(localStorage.getItem("pageHistory") || "[]"))
    : JSON.stringify([{ url: window.location.href, ts: Date.now() }]);

  fetch("https://stylavoteam.com/shopify/nitro/save_user_data.php", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({ email, phone, pages })
  }).catch(() => {});

//   fetch("https://stylavoteam.com/shopify/nitro/save_user_data.php", {
//     method: "POST",
//     headers: { "Content-Type": "application/x-www-form-urlencoded" },
//     body: new URLSearchParams({ email, phone, pages })
//   })
//   .then(res => res.json())
//   .then(data => console.log("✅ Synced:", data))
//   .catch(err => console.error("❌ Sync error:", err));
}

document.addEventListener("DOMContentLoaded", () => {
  const phone =
  localStorage.getItem("userPhone") ||
  localStorage.getItem("return_contact") ||
  "";
  if (phone && phone.length === 10 && localStorage.getItem("historySynced")) {
    syncUserData(false);
  }
});





document.addEventListener('DOMContentLoaded', function () {
  const html = document.documentElement;

  function isAnyDrawerOpen() {
    const search = document.querySelector('dialog.search-modal__content');
    const cart = document.querySelector('dialog[aria-labelledby="cart-drawer-heading"]');

    return (
      (search && search.hasAttribute('open')) ||
      (cart && cart.hasAttribute('open'))
    );
  }

  function fixScrollLock() {
    if (!isAnyDrawerOpen()) {
      html.removeAttribute('scroll-lock');
    }
  }

  const observer = new MutationObserver(fixScrollLock);

  observer.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['open', 'scroll-lock']
  });

  fixScrollLock();
});




// document.addEventListener("DOMContentLoaded", function () {
//   const section = document.querySelector(
//     '#shopify-section-sections--22803446923519__header_announcements_9jGBFp'
//   );

//   if (!section) return;


//   const saleEnd = new Date("2026-08-31T11:00:00+05:30").getTime();

//   section.innerHTML = `
//     <div class="stylavo-sale-bar">
//       <div class="stylavo-sale-content">

//         <span class="stylavo-sale-text">
//           FLAT 40% OFF <span class="stylavo-separator">|</span> 48 HOURS ONLY
//         </span>

//         <div class="stylavo-countdown">

//           <div class="stylavo-time-box">
//             <span id="stylavo-hours">00</span>
//             <small>hrs</small>
//           </div>

//           <span class="stylavo-colon">:</span>

//           <div class="stylavo-time-box">
//             <span id="stylavo-minutes">00</span>
//             <small>min</small>
//           </div>

//           <span class="stylavo-colon">:</span>

//           <div class="stylavo-time-box">
//             <span id="stylavo-seconds">00</span>
//             <small>sec</small>
//           </div>

//         </div>

//       </div>
//     </div>
//   `;



//   const style = document.createElement("style");

//   style.innerHTML = `
//     .stylavo-sale-bar {
//       width: 100%;
//       background: #b21f32;
//       color: #ffffff;
//       box-sizing: border-box;
//       padding: 8px 15px;
//       border-bottom: 1px solid rgba(255,255,255,0.25);
//     }

//     .stylavo-sale-content {
//       min-height: 43px;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       gap: 12px;
//       font-family: Arial, Helvetica, sans-serif;
//     }

//     .stylavo-sale-text {
//       font-size: 17px;
//       font-weight: 400;
//       letter-spacing: 0.2px;
//       white-space: nowrap;
//     }

//     .stylavo-separator {
//       opacity: 0.7;
//       margin: 0 4px;
//     }

//     .stylavo-countdown {
//       display: flex;
//       align-items: center;
//       gap: 6px;
//     }

//     .stylavo-time-box {
//       min-width: 62px;
//       height: 34px;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       gap: 5px;
//       background: rgba(120, 0, 20, 0.35);
//       padding: 0 8px;
//       box-sizing: border-box;
//     }

//     .stylavo-time-box span {
//       font-size: 17px;
//       font-weight: 400;
//       line-height: 1;
//     }

//     .stylavo-time-box small {
//       font-size: 16px;
//       font-weight: 400;
//       line-height: 1;
//     }

//     .stylavo-colon {
//       font-size: 18px;
//       opacity: 0.8;
//     }

//     /* MOBILE */
//     @media screen and (max-width: 600px) {

//       .stylavo-sale-bar {
//         padding: 8px 8px;
//       }

//       .stylavo-sale-content {
//         gap: 7px;
//       }

//       .stylavo-sale-text {
//         font-size: 11px;
//         letter-spacing: 0;
//       }

//       .stylavo-separator {
//         margin: 0 2px;
//       }

//       .stylavo-countdown {
//         gap: 3px;
//       }

//       .stylavo-time-box {
//         min-width: 42px;
//         height: 27px;
//         padding: 0 4px;
//         gap: 2px;
//       }

//       .stylavo-time-box span {
//         font-size: 12px;
//       }

//       .stylavo-time-box small {
//         font-size: 10px;
//       }

//       .stylavo-colon {
//         font-size: 12px;
//       }
//     }
//   `;

//   document.head.appendChild(style);

//   function updateCountdown() {

//     const now = Date.now();
//     const distance = saleEnd - now;

//     if (distance <= 0) {
//       document.getElementById("stylavo-hours").textContent = "00";
//       document.getElementById("stylavo-minutes").textContent = "00";
//       document.getElementById("stylavo-seconds").textContent = "00";
//       return;
//     }

//     const hours = Math.floor(distance / (1000 * 60 * 60));
//     const minutes = Math.floor(
//       (distance % (1000 * 60 * 60)) / (1000 * 60)
//     );
//     const seconds = Math.floor(
//       (distance % (1000 * 60)) / 1000
//     );

//     document.getElementById("stylavo-hours").textContent =
//       String(hours).padStart(2, "0");

//     document.getElementById("stylavo-minutes").textContent =
//       String(minutes).padStart(2, "0");

//     document.getElementById("stylavo-seconds").textContent =
//       String(seconds).padStart(2, "0");
//   }

//   updateCountdown();
//   setInterval(updateCountdown, 1000);
// });
